import Api from '../../api/Api'

const quiz = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    user_quiz: {},
    event_pretest: {},
    pretestuser: [],
    empty: '',
  },

  //mutations
  mutations: {
    SET_USER_QUIZ(state, data) {
      state.user_quiz = data
    },
    SET_USER_PRETEST(state, data) {
      state.pretestuser = data
    },
    SET_EVENT_PRETEST(state, data) {
      state.event_pretest = data
    },
    SET_EMPTY(state, empty) {
      state.empty = empty
    },
  },

  //actions
  actions: {
    user_quiz({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/quiz/userquiz?id_aktifitas=${data.id_aktifitas}`)
          .then((response) => {
            commit('SET_USER_QUIZ', response.data.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    user_pretest({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/quiz/userquizpretest?id_event=${data.id_event}&tipe=${data.tipe}&isCoba=${data.isCoba}`,
        )
          .then((response) => {
            commit('SET_USER_PRETEST', response.data.data)
            commit('SET_EVENT_PRETEST', response.data.event)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    jawab_pretest({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/quiz/userquizpretestmenjawab`, data)
          .then((response) => {
            commit('SET_USER_PRETEST', '')
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    jawabstudykasus({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/quiz/userquizstudykasusmenjawab`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            commit('SET_USER_PRETEST', '')
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getUserQuiz(state) {
      return state.user_quiz
    },
    getUserPretest(state) {
      return state.pretestuser
    },
    getEventPretest(state) {
      return state.event_pretest
    },
  },
}

export default quiz
